import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { IoConfigActions, ioConfigActions } from "../../../actions/ioConfigActions";
import styles from "./SearchEvents.module.scss";

import magnifier from "../../../images/magnifier.svg";
import arrow_down from "../../../images/chevron-down.svg";
import arrow_up from "../../../images/chevron-up.svg";
type StateProps = {
  ioConfig: State.IoConfig;
  pdApi: State.PdApi;
};

type DispatchProps = {
  ioConfigActions: typeof ioConfigActions;
};

type OwnProps = {
  searchText: string;
  setSearchText: (searchTerm: string) => void;
  currentNodeId?: string;
  onSearchTextChange: () => void;
  numberOfResults: number | null;
  currentIndex: number;
  onSearchSubmitClick: (searchTerm: string, nodeId: string | undefined) => void;
  onNextResultClick: (direction: "up" | "down") => void;
  onSearchAllClick?: (searchTerm: string) => void;
  onSearchNextNodeClick?: (searchTerm: string, getFirstNode?: boolean) => void;
};
const SearchEvents = (props: StateProps & DispatchProps & OwnProps) => {
  const {
    searchText,
    setSearchText,
    pdApi,
    onSearchSubmitClick,
    onNextResultClick,
    numberOfResults,
    onSearchTextChange,
    currentIndex,
    currentNodeId,
    onSearchNextNodeClick
  } = props;

  const [foundSingleEnum, setFoundSingleEnum] = useState(false);
  const eventClasses = pdApi.eventClasses.map(ec => ec.enumName);
  const eventTypes = pdApi.eventTypes.map(et => et.enumName);
  const searchOptions = eventClasses.concat(eventTypes);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleOnSearchChange = (e: any) => {
    const value = e.target.value.toUpperCase();
    if (foundSingleEnum) {
      if (searchText.length > value.length) {
        setSearchText("");
        setFoundSingleEnum(false);

        return;
      } else {
        return;
      }
    }
    const foundOptions = searchOptions.filter(o => o.includes(value));
    if (foundOptions.length === 1) {
      setFoundSingleEnum(true);
      setSearchText(foundOptions[0]);
    } else {
      setSearchText(value);
    }
    onSearchTextChange();
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onKeyPress = (e: any) => {
    if (e.which === 13) {
      onSearchSubmitClick(searchText, currentNodeId); // Submit on enter key press
    }
  };
  return (
    <div>
      <div className={styles.SearchForm} style={{ maxWidth: "300px" }}>
        <input
          type="text"
          placeholder="Find event class or type..."
          value={searchText}
          onChange={e => handleOnSearchChange(e)}
          onKeyPress={onKeyPress}
        />
        <button
          disabled={searchText === ""}
          onClick={() => onSearchSubmitClick(searchText, currentNodeId)}
        >
          <img src={magnifier} alt="search" />
        </button>
        {numberOfResults !== null && numberOfResults > 0 && (
          <>
            <button className={styles.arrowButtons} onClick={() => onNextResultClick("up")}>
              <img src={arrow_up} alt="arrow_up" />
            </button>
            <button className={styles.arrowButtons} onClick={() => onNextResultClick("down")}>
              <img src={arrow_down} alt="arror_down" />
            </button>
          </>
        )}
      </div>
      {numberOfResults !== null && numberOfResults > 0 ? (
        <>
          <span className={styles.numberOfResultsSpan}>
            Showing result {currentIndex + 1} of {numberOfResults} events found.
          </span>
          {onSearchNextNodeClick && (
            <span
              className={styles.searchAllButton}
              onClick={() => onSearchNextNodeClick(searchText)}
            >
              Search next node
            </span>
          )}
        </>
      ) : numberOfResults === 0 ? (
        <>
          <span className={styles.numberOfResultsSpan}>No events found.</span>
          {onSearchNextNodeClick && (
            <span
              className={styles.searchAllButton}
              onClick={() => onSearchNextNodeClick(searchText)}
            >
              Search next node
            </span>
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};
const mapStateToProps = (state: State.Root) => ({
  ioConfig: state.ioConfig,
  pdApi: state.pdApi
});
const mapDispatchToProps = (dispatch: Dispatch<IoConfigActions>) => ({
  ioConfigActions: bindActionCreators({ ...ioConfigActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchEvents);
